module.exports = __webpack_public_path__ + "img/YouTube.ae931fb2.svg";